__turbopack_context__.v({
  "illustration": "styles-module__RGjKdq__illustration",
  "largeIllustration": "styles-module__RGjKdq__largeIllustration",
  "mobileText": "styles-module__RGjKdq__mobileText",
  "signupCta": "styles-module__RGjKdq__signupCta",
  "signupPanel": "styles-module__RGjKdq__signupPanel",
  "smallText": "styles-module__RGjKdq__smallText",
});
